import { render, staticRenderFns } from "./BannerStore.vue?vue&type=template&id=1dd15bc2&scoped=true"
import script from "./BannerStore.vue?vue&type=script&lang=js"
export * from "./BannerStore.vue?vue&type=script&lang=js"
import style0 from "./BannerStore.vue?vue&type=style&index=0&id=1dd15bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd15bc2",
  null
  
)

export default component.exports